<template>
	<div id="top-page" v-on:click="hideMenus">
		<nav>
			<reserve-component :toppos="true"></reserve-component>
			<menus-component :burger="true" :parentPage="'top-page'"></menus-component>
		</nav>
		<main>
			<!--
			<div class="slide-area" :style="{'background-image': 'url(/static/slideshow/' + slideItems[slideBgNum] + '.jpg)', 'background-image': 'url(/static/slideshow/' + slideItems[slideBgNum] + '.webp)'}">
				<transition name="slide"><div class="slide" :key="slideItems[slideNum]" :style="{'background-image': 'url(/static/slideshow/' + slideItems[slideNum] + '.jpg)', 'background-image': 'url(/static/slideshow/' + slideItems[slideNum] + '.webp)'}"></div></transition>
			</div>
			-->
			<div class="slide-area" :style="{'background-image': 'url(/static/slideshow/' + slideItems[slideBgNum] + '.jpg)'}">
				<transition name="slide"><div class="slide" :key="slideItems[slideNum]" :style="{'background-image': 'url(/static/slideshow/' + slideItems[slideNum] + '.jpg)'}"></div></transition>
			</div>
			<!-- <div class="message-area">
				<img class="mess" src="/static/message.png"/>
			</div> -->
		</main>
		<footer>
			<div class="footer-area">
				<menus-component :burger="false" :parentPage="'top-page'"></menus-component>
				<div class="comment">
					<span style="font-size:1.2rem; color:#fe83cc">食・飲・話</span><br>
					<span>おいしい料理と楽しいお酒。お客様との会話も大切に。</span>
				</div>
				<div class="logo-area">
					<img class="logo" src="/static/logo.png" alt="ロゴ" />
				</div>
				<div class="address">
					<span>沖縄県那覇市久茂地2-18-21</span><br>
					<span>098-864-2258</span>
				</div>
				<div class="info">
					月～木・祝日/18:00～24:00<br>
					金・土 /18:00～1:00
				</div>
				<div class="copyright">Copyright &copy; DINING 花 All rights reserved. 無断転載禁止</div>
			</div>
		</footer>
		<div v-if="warnFlg" class="warn">
			<div class="close_btn" @click.stop="warn_close"></div>
			<div class="warn-title">{{warntitle}}</div>
			<div class="warn-kikan">{{warnsubText}}</div>
			<div class="warn-comment">{{warncomment}}</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import menus from '@/components/template/menu.vue'
import resbtn from '@/components/template/reserveButton.vue'
import '@/js/modernizr-custom.js';
export default {
	name:"top-page",
	components: {
		'menus-component': menus,
		'reserve-component': resbtn
	},
	data() {
		return {
			slideNum: 0,
			slideBgNum: 0,
			slideTimer: null,
			slideItems: [],
			slideImages: [],
			warnFlg: false,
			warntitle: "",
            warnsubText: "",
            warncomment: ""
		}
	},
	created() {
		
	},
	mounted() {
		this.$nextTick(function(){

			this.getWarn();

			this.preLoader().then(() => {
				this.onTimer();
			});
		});
		//this.onTimer();
		//this.loadImages();
		/*
		this.$nextTick(function(){
			this.loadImages();
			this.slideNum = 0;
			this.slideTimer = "";
			setTimeout(function(){
				this.slideShow(true);
			}.bind(this), 100);
		});
		*/
	},
	methods: {
		async preLoader() {
			try {
				let param = {};
				
				let request = {
					timeout: 60000,
					withCredentials: true,
					responseType: 'json',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					}
				};
				
				//let response = await Vue.$http.post('/cgi-bin/topimages.py', param, request);
				let response = await Vue.$http.get('/cgi-bin/topimages.py', request);
				
				this.slideItems = response.data.Images;
				
				for (let i = 0; i < this.slideItems.length; i++) {
					var _image = new Image();
					_image.src = "/static/slideshow/" + this.slideItems[i] + ".jpg";
					/*
					if (Modernizr.webp) {
						_image.src = "/static/slideshow/" + this.slideItems[i] + ".webp";
					} else {
						_image.src = "/static/slideshow/" + this.slideItems[i] + ".jpg";
					}
					*/
					//_image.src = "/static/slideshow/" + this.slideItems[i] + ".jpg";
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getWarn() {
            try {
                let request = {
					timeout: 60000,
					withCredentials: true,
					responseType: 'json',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					}
				};
				
				let response = await Vue.$http.get('/cgi-bin/warn.py', request);
                
                if (response.data.status != undefined) {
                    if (response.data.status == 'ok') {
                        this.warnFlg = (response.data.warn.notFlg == 1) ? false : true;
                        this.warntitle = response.data.warn.title;
                        this.warnsubText = response.data.warn.subText;
						this.warncomment = response.data.warn.comment;
						
						if (this.warnFlg) {
							let flg = this.$cookie.get('warn_win');
							if (flg == "1") {
								this.warnFlg = false;
							}
						}
                    }
                }
            } catch (error) {
				console.error(error);
			}
        },
		nextSlide: function() {
			this.slideBgNum = this.slideBgNum < this.slideItems.length - 1 ? this.slideBgNum += 1 : 0;
			
			this.slideNum = this.slideBgNum;
			
			//let slide = this.$el.querySelector(".slide-area");
			//slide.style.backgroundImage = "url(/static/slideshow/" + this.slideItems[sn] + ")";
		},
		onTimer: function () {
			this.slideTimer = setInterval(() => {
				this.nextSlide();
			}, 5000)
		},
		offTimer: function () {
			if(this.slideTimer === null) {
				this.onTimer();
			} else {
				clearInterval(this.slideTimer);
				this.slideTimer = null;
			}
		},
		hideMenus() {
			let bmnus = this.$el.querySelector(".burger-menu-area");
			bmnus.classList.remove('burger-menu-active');
		},
		getImages() {
			
		},
		warn_close() {
			this.warnFlg = false;
			this.$cookie.set('warn_win', '1');
		}
	}
}
</script>

<style lang="less">
@import '../less/reset.less';
@import '../less/default.less';
@import '../less/const.less';
#top-page {
	height: 100vh;
	
	.slide-area {
		position: fixed;
		width: 100vw;
		height: calc(100vh - 160px);
		top: 0;
		left: 0;
		overflow: hidden;
		background-size: cover;
		background-position: center;
		
		.slide {
			width: 100%;
			height: 100%;
			background-size: cover;
			background-position: center;
			z-index: 2;
		}
	}
	
	/* .message-area {
		position: fixed;
		z-index: 900;
		left: calc((100% / 2) - 7%);
		padding-top: 24px;
		
		.mess {
			height: calc(100vh - 100px);
		}
	} */
	
	.footer-area {
		position: fixed;
		bottom: 0;
		height: 160px;
		width: 100%;
		background-color: #0e0b06;
		color: #ffe0e0;
		padding: 8px;
		
		.comment {
			position: fixed;
			right: 8px;
			margin-top: 12px;
		}
		
		.logo-area {
			position: fixed;
			
			.logo {
				position: absolute;
				top: -90px;
				left: -6px;
				width: 280px;
				height: 142.8px;
			}
		}
		
		.address {
			position: fixed;
			bottom: 18px;
		}
		
		.info {
			position: fixed;
			bottom: 18px;
			left: 200px;
			/* font-size: 0.6rem; */
		}
		
		.copyright {
			position: fixed;
			left: 0;
			bottom: 4px;
			width: 100%;
			text-align: center;
			/* font-size: 0.8rem; */
			font-family:
				"メイリオ", Meiryo,
				"ヒラギノ角ゴ ProN W3",
				"MS UI Gothic",
				"Lucida Grande",
				Tahoma,
				"ヒラギノ丸ゴ Pro W4",
				sans-serif;
		}
	}

	.warn {
		position: absolute;
		height: 226px;
		width: 320px;
		vertical-align: middle;
		padding: 10px 16px;
		top: 0;
		left: 0;
		right: 0;
		bottom: 180px;
		margin: auto;
		background-color: white;
		border-radius: 12px;
		box-shadow: 4px 4px 12px 6px rgba(0,0,0,0.2);
		font-family:
				"メイリオ", Meiryo,
				"ヒラギノ角ゴ ProN W3",
				"MS UI Gothic",
				"Lucida Grande",
				Tahoma,
				"ヒラギノ丸ゴ Pro W4",
				sans-serif;
		
		.warn-title {
			font-size: 1.6rem;
			font-weight: bold;
		}

		.warn-kikan {
			margin-bottom: 12px;
		}

		.close_btn {
			position: absolute;
			width: 32px;
			height: 32px;
			top: -16px;
			right: -16px;
			background-color: white;
			border-radius: 16px;
			border: 2px solid #000;
			cursor: pointer;

			&::before, &::after {
				content: "";
				display: block;
				width: 70%;/*バツ線の長さ*/
				height: 3px;/*バツ線の太さ*/
				background: #000;
				transform: rotate(45deg);
				transform-origin:0% 50%;
				position: absolute;
				top: calc(24% - 1.5px);
				left: 24%;
			}

			&::after {
				transform: rotate(-45deg);
				transform-origin:100% 50%;
				left: auto;
				right: 24%;
			}
		}
	}
}

.slide-enter-active, .slide-leave-active {
	transition: transform .5s;
}
.slide-enter {
	transform: translateX(100vw);
}
.slide-leave-active {
	transform: translateX(calc(100vw * -1));
}

@media(max-width:768px) and (min-width: 621px){
	#top-page {
		.slide-area {
			width: 100vw;
			height: calc(100vh - 160px);
			top: 0;
			left: 0;
			
			.slide {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-position: center;
			}
			
			.slide-sub {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-position: center;
			}
		}
		
		/* .message-area {
			display: none;
		} */
		
		.footer-area {
			.info {
				bottom: 26px;
			}
		}
	}
}

@media(max-width:825px) {
	#top-page {
		.footer-area {
			
		}
	}
}

@media(max-width:620px) {
	#top-page {
		.slide-area {
			width: 100vw;
			height: calc(100vh - 200px);
			top: 0;
			left: 0;
			
			.slide {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-position: center;
			}
			
			.slide-sub {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-position: center;
			}
		}
		
		/* .message-area {
			display: none;
		} */
		
		.footer-area {
			height: 200px;
			
			.comment {
				margin-top: 42px;
			}
			
			.address {
				bottom: 32px;
			}
			
			.info {
				bottom: 36px;
			}
			
			.copyright {
				/* font-size: 0.6rem; */
			}
		}
	}
}

@media(max-width:620px) and (max-height:390px) {
	#top-page {
		
		.slide-area {
			width: 100vw;
			height: calc(100vh - 120px);
			top: 0;
			left: 0;
			
			.slide {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-position: center;
			}
			
			.slide-sub {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-position: center;
			}
		}
		
		/* .message-area {
			display: none;
		} */
		
		.footer-area {
			height: 120px;
			
			.comment {
				margin-top: 10px;
				/* font-size: 0.8rem; */
			}
			
			.address {
				bottom: 32px;
				/* font-size: 0.8rem; */
			}
			
			.info {
				left: 22px;
				bottom: 2px;
			}
			
			.copyright {
				/* font-size: 0.6rem; */
			}
		}
	}
}

@media(max-width:570px) and (max-height:340px) {
	#top-page {
		.slide-area {
			width: 100vw;
			height: calc(100vh - 120px);
			top: 0;
			left: 0;
			
			.slide {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-position: center;
			}
			
			.slide-sub {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-position: center;
			}
		}
		
		/* .message-area {
			display: none;
		} */
		
		.footer-area {
			height: 120px;
			
			.comment {
				margin-top: 10px;
				/* font-size: 0.8rem; */
			}
			
			.address {
				bottom: 32px;
				/* font-size: 0.8rem; */
			}
			
			.info {
				left: 22px;
				bottom: 2px;
			}
			
			.copyright {
				/* font-size: 0.6rem; */
			}
		}
	}
}

@media(max-width:416px) {
	#top-page {
		.slide-area {
			width: 100vw;
			height: calc(100vh - 200px);
			top: 0;
			left: 0;
			
			.slide {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-position: center;
			}
			
			.slide-sub {
				width: 100%;
				height: 100%;
				background-size: cover;
				background-position: center;
			}
		}
		
		/* .message-area {
			display: none;
		} */
		
		.footer-area {
			height: 200px;
			
			.comment {
				margin-top: 42px;
				/* font-size: 0.8rem; */
			}
			
			.logo-area {
				.logo {
					top: -90px;
					width: 224px;
					height: 114.2px;
				}
			}
			
			.address {
				bottom: 42px;
				/* font-size: 0.8rem; */
			}
			
			.info {
				left: 180px;
			}
			
			.copyright {
				/* font-size: 0.6rem; */
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue